export default __webpack_public_path__ + "static/media/es_black.bc588dbd.svg";